import { Mic2, ArrowDown, ArrowUp, Bot, Church, Radio, Loader2, Star } from "lucide-react";
import { EFFECTS } from "../lib/voiceEffects";
import { useI18n } from "../context/I18nContext";

const ICONS = { normal: Mic2, deep: ArrowDown, high: ArrowUp, robot: Bot, cathedral: Church, radio: Radio };

export const VoiceEffectPicker = ({ value, onChange, processing, disabled, favorite, onSetFavorite }) => {
  const { t } = useI18n();
  return (
    <div>
      <span className="label-gold flex items-center gap-2 mb-3">
        {t("fx_label")} {processing && <Loader2 size={12} className="animate-spin" />}
      </span>
      <div className="grid grid-cols-3 sm:grid-cols-6 gap-2" data-testid="voice-effect-picker">
        {EFFECTS.map((fx) => {
          const Icon = ICONS[fx];
          const active = value === fx;
          return (
            <button
              key={fx}
              data-testid={`voice-effect-${fx}`}
              disabled={disabled || processing}
              onClick={() => onChange(fx)}
              className={`relative flex flex-col items-center gap-1.5 py-3 rounded-xl border text-xs transition-colors duration-200 disabled:opacity-60 ${
                active ? "bg-[#E5C158]/15 border-[#E5C158] text-[#E5C158]" : "border-white/10 text-[#C2C9DB] hover:border-[#E5C158]/40"
              }`}
            >
              {favorite === fx && <Star size={10} fill="#E5C158" className="absolute top-1.5 right-1.5 text-[#E5C158]" data-testid={`voice-effect-favorite-${fx}`} />}
              <Icon size={18} strokeWidth={1.6} />
              {t(`fx_${fx}`)}
            </button>
          );
        })}
      </div>
      <div className="flex flex-wrap items-center justify-between gap-2 mt-3">
        {value !== "normal" ? <p className="text-xs text-[#8E9BB4]">{t("fx_note")}</p> : <span />}
        {onSetFavorite && value !== favorite && (
          <button data-testid="voice-effect-set-favorite-btn" disabled={disabled} onClick={() => onSetFavorite(value)} className="inline-flex items-center gap-1.5 text-xs text-[#E5C158] hover:text-[#F0D375]">
            <Star size={12} /> {t("fx_set_fav")}
          </button>
        )}
      </div>
    </div>
  );
};
